import GlobalAxios from "../axios/axios-config";
import TemporaryAxios from "../axios/temprary-axios-config";
import { IHasUser } from "../models/authorizations";
import { IDownloadExamsParams, IExams } from "../models/exams";
import { ISearchParams, ISearchReturn } from "../models/requests";

const EXAMS_ROUTE = process.env.REACT_APP_APP + "/api/v1/LaboratorialExams";

const MANAGEMENT_EXAMS_ROUTE =
  process.env.REACT_APP_APP + "/api/v1/ManagementLaboratorialExams";

const EXAMS_TASY_ROUTE =
  process.env.REACT_APP_APP + "/api/v1/LaboratorialExams/Tasy";

const BASE_URL = process.env.REACT_APP_IDENTIY;
const PACS_REQUEST_TIMEOUT = 30000;

export interface IGetExamsParams extends ISearchParams {
  ExamType?: string;
  StartDate?: string;
  EndDate?: String;
  IndividualId?: string;
  InternalProcedureCode?: number;
}

interface IGetPixeonUrlParams {
  Integrationid: string;
}

export const getExams = (params?: IGetExamsParams) => {
  return GlobalAxios.get<ISearchReturn<IExams>>(EXAMS_ROUTE, {
    params,
  });
};

export const getManagementExams = (params?: IGetExamsParams) => {
  return GlobalAxios.get<ISearchReturn<IExams>>(MANAGEMENT_EXAMS_ROUTE, {
    params,
  });
};

export const emptyManagementExamReleaseDate = (Identifier: number) => {
  return GlobalAxios.put(`${MANAGEMENT_EXAMS_ROUTE}/EmptyReleaseDate`, {
    identifier: Identifier
  });
};

export const getTasyExams = (params?: IGetExamsParams) => {
  return TemporaryAxios.get<ISearchReturn<IExams>>(EXAMS_TASY_ROUTE, {
    params,
  });
};

export const downloadExamTemporary = (params: IDownloadExamsParams) => {
  return TemporaryAxios.get<ISearchReturn<IExams>>(
    EXAMS_ROUTE + `/${params.id}`,
    {
      params: { examType: params.examType },
    },
  );
};

export const downloadExam = (params: IDownloadExamsParams) => {
  return GlobalAxios.get<ISearchReturn<IExams>>(EXAMS_ROUTE + `/${params.id}`, {
    params: { examType: params.examType, individualId: params.individualId },
  });
};

export const hasUserService = () => {
  return TemporaryAxios.get<IHasUser>(BASE_URL + "/api/v1/Login/HasUser");
};

export const getPixeonUrl = (params?: IGetPixeonUrlParams) => {
  return GlobalAxios.get<string>(
    EXAMS_ROUTE + `/Pixeon/${params?.Integrationid}`,
    { timeout: PACS_REQUEST_TIMEOUT },
  );
};

export const getTasyPixeonUrl = (params?: IGetPixeonUrlParams) => {
  return TemporaryAxios.get<string>(
    EXAMS_TASY_ROUTE + `/Pixeon/${params?.Integrationid}`,
    { timeout: PACS_REQUEST_TIMEOUT },
  );
};

export const getVueMotionUrl = (params?: IGetPixeonUrlParams) => {
  return GlobalAxios.get<string>(
    EXAMS_ROUTE + `/VueMotionPacs/${params?.Integrationid}`,
    { timeout: PACS_REQUEST_TIMEOUT },
  );
};

export const getTasyVueMotionUrl = (params?: IGetPixeonUrlParams) => {
  return TemporaryAxios.get<string>(
    EXAMS_TASY_ROUTE + `/VueMotionPacs/${params?.Integrationid}`,
    { timeout: PACS_REQUEST_TIMEOUT },
  );
};
